export const Subjects = [
  "Press & Communications",
  "New Customer",
  "Human Resources",
  "Finance",
  "Transportation",
  "Warehouse",
  "Other",
] as const;

export type Subject = (typeof Subjects)[number];

export const Warehouses = [
  "Lebanon, IN, US",
  "McDonough, GA, US",
  "Tacoma, WA, US",
  "Burley, ID, US",
  "Rennes, France",
  "Argentan, France",
  "Rheine, Germany",
  "Piacenza, Italy",
  "Borgorose, Italy",
  "Kutno, Poland",
  "Lisbon, Portugal",
  "Palmela, Portugal",
  "Helsingborg, Sweden",
  "Corby, UK",
  "Wakefield, UK",
  "Kruiningen, The Netherlands",
  "Melbourne I, Australia",
  "Melbourne II, Australia",
  "Bucharest, Romania",
  "Modlin Nowy (Warsaw), Poland",
  "Dinteloord, Netherlands",
  "Coaldale (Alberta), Canada",
] as const;

export type Warehouse = (typeof Warehouses)[number];
